import { ComponentProps, FC } from 'react'

import {
  Text,
  NumberFieldInput,
  Primary13Regular,
  RedRed60,
  Flex
} from '@sequencehq/core-components'
import { ValidationResult } from '../validation'

export {
  InputSelectControlField,
  TextInputField
} from '@sequencehq/core-components'

export const NumberInputField: FC<
  ComponentProps<typeof NumberFieldInput> & {
    validationErrors: ValidationResult[] | undefined
  }
> = ({ validationErrors, ...props }) => {
  return (
    <Flex gap="8px" flexDirection="column">
      <NumberFieldInput {...props} />
      {validationErrors?.at(0) && (
        <Text {...Primary13Regular} color={RedRed60}>
          {validationErrors.at(0)?.message}
        </Text>
      )}
    </Flex>
  )
}
